import Image from 'next/image';

import { DealCampaign } from '~/lib/browse/types';
import {
  BLACK_FRIDAY_CAMPAIGN,
  SUMO_DAY_CAMPAIGN,
} from '~/lib/campaigns/constants';

import blackFridayBadge from '~/public/black-friday-badge.svg';
import sumodayBadge from '~/public/sumoday-flag.svg';

function BigBoiBadge({ campaign }: { campaign: DealCampaign }) {
  let svgBadge = '';

  if (campaign.type === BLACK_FRIDAY_CAMPAIGN) {
    svgBadge = blackFridayBadge;
  }

  if (campaign.type === SUMO_DAY_CAMPAIGN) {
    svgBadge = sumodayBadge;
  }

  if (!svgBadge) {
    return null;
  }

  return (
    <Image
      src={svgBadge}
      alt={campaign.text}
      className="absolute left-0 top-6"
    />
  );
}

export default BigBoiBadge;
